import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
// import p1 from 'assests/Photos/LifeSkill2023/2024/CareerGuidance/1.jpg';
// import p2 from 'assests/Photos/LifeSkill2023/2024/CareerGuidance/2.jpg';
// import p3 from 'assests/Photos/LifeSkill2023/2024/CareerGuidance/3.jpg';
// import p4 from 'assests/Photos/LifeSkill2023/2024/CareerGuidance/4.jpg';
// import p5 from 'assests/Photos/LifeSkill2023/Roadsafty/5.jpg';
// import p6 from 'assests/Photos/LifeSkill2023/Roadsafty/6.jpg';
// import p7 from 'assests/Photos/LifeSkill2023/Roadsafty/7.jpg';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Sidebar2023 from 'views/LifeSkill2023/Sidebar2023';
import Archive2022 from '../LifeSkill2023/Archive2022';
import Sidebar2026 from '../LifeSkill2023/Sidebar2026';

const CareerGuidance2026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  
  useEffect(() => {
    fetch('/config.json') // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const p1 = `${config.base_image_url_2026}/home/events-activities/life-skill/Career/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/life-skill/Career/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/life-skill/Career/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/life-skill/Career/4.webp`;
  const p5 = `${config.base_image_url_2026}/home/events-activities/life-skill/Career/5.webp`;



  const photos = [
    {
      src: p1,
      source: p1,
      rows: 1.2,
      cols: 1,
    },
    {
      src: p2,
      source:p2,
      rows: 1.2,
      cols: 1,
    },
    {
      src: p3,
      source: p3,
      rows: 1,
      cols: 1,
    },

    {
      src: p4,
      source: p4,
      rows: 1,
      cols: 1,
    },

    {
        src: p5,
        source: p5,
        rows: 1,
        cols: 1,
      },

  ];

  return (
    <Main>
   
<Container>

  <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center' >
       CAREER GUIDANCE PROGRAMME
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
      Date: 8 August 2026
        </Typography>

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        
National Public School, Yeshwanthpur, organised an insightful Career Guidance Programme on 8
August 2026 for students and parents. The programme aimed to familiarise students with emerging
opportunities and equip them with the knowledge and guidance needed to make informed
decisions about their academic and career pathways.
        <br/>
        
The session was conducted by Lodestar Guidance, an organisation committed to helping students
identify suitable career pathways through expert guidance and scientific career planning. Mr.
Murlidhar S, Founder and CEO of Lodestar Career Guidance, was the distinguished resource person
for the programme. During the session, students were encouraged to explore diverse career
possibilities, understand their personal strengths and interests, set meaningful goals and develop a
clear roadmap towards achieving them. The programme provided valuable perspectives to students
and parents, enabling them to approach career decisions with greater awareness, clarity and
confidence.
        <br/>
The participation of parents added further value to the programme, creating an opportunity for
them to understand the importance of supporting their children in making career choices based on
individual potential and aspirations.
        <br/>
Overall, the Career Guidance Programme was an enriching and empowering experience that
encouraged students to look beyond conventional choices, recognise their strengths and approach
their future with purpose and confidence. The session reinforced the message that the right career
choice begins with self-awareness, informed exploration and a clear vision for the future.
        <br/>
        </Typography>
      </Box>
      {/* <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
       “OPPORTUNITIES DON'T HAPPEN, YOU CREATE THEM”

<br/>
        </Typography> */}

      <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 200 : 100}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>

    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <Sidebar2026/>
             </Box>
             <Box marginBottom={4}>
               <Archive2022/>
             </Box>

    </Grid>
    </Grid> 
    </Container>
    </Main>
   
   
  );
};

export default CareerGuidance2026;